import React from 'react'
import RealEstateHero from './RealEstatePages/RealEstate'
import InfoSection from './InfoSection'
import RealEstateFeatures from './RealEstatePages/RealEstateFeatures'

function RealEstatePage() {
  return (
    <div>
      <RealEstateHero />
      <InfoSection />
      <RealEstateFeatures />
    </div>
  )
}

export default RealEstatePage